import React, { useState, useEffect } from "react";

import axios from "axios";

// Components
import Preloader from "../../../components/Preloader/Preloader";
import { NavLink } from "react-router-dom";
import MUIDataTable from "mui-datatables";
//Date Range
import { addDays, format } from "date-fns";
import { DateRangePicker } from "materialui-daterange-picker";

//Material UI Icons
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
// Material UI Component
import {
	FormGroup,
	FormLabel,
	FormControl,
	FormHelperText,
	NativeSelect,
	// ListItemText,
	TextField,
	// Checkbox,
	// FormControlLabel,
	// Grid,
	// Select,
	Input,
	InputLabel,
	// MenuItem,
	Modal,
	Backdrop,
	//Fade,
	fade,
	Button,
	Grid,
	Breadcrumbs,
	Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
// Material Icons
import { AssessmentTwoTone, FaceRounded } from "@material-ui/icons";
import {get_cookies, isLoggedIn} from "../../../components/Cookies/Cookies";

const useStyles = makeStyles((theme) => ({
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
	textField: {
        marginTop: '-15px',
    },
	// paper: {
	// 	backgroundColor: theme.palette.background.paper,
	// 	border: "2px solid #000",
	// 	boxShadow: theme.shadows[5],
	// 	padding: theme.spacing(2, 4, 3),
	// },
}));

const CustomerInfo = () => {
	const [posts, setPosts] = useState([]);
	const [dataLoaded, setDataLoaded] = useState(true);
	const [open, setOpen] = useState(false);
	const [modalOpen, setModalOpen] = useState(false);
	const [dateRange, setDateRange] = useState({
		startDate: new Date(),
		endDate: addDays(new Date(), 7),
	});
	const [filterType, setFilterType] = useState("1");
	const [customerName, setCustomerName] = useState('');
	const [idno, setIdno] = useState('');
	const [downloadFlag, setDownloadFlag] = useState(false);
	const [btnDisabled, setBtnDisabled] = useState(true);
	const classes = useStyles();
	//console.log(format(dateRange.endDate, "yyyy/MM/dd/"));


	// Data Fetching
	useEffect(() => {
		//data(); only load table data when user has searched //for Entity >> Customer
	}, []);

	const x = 0;
	useEffect(() => { //
		isLoggedIn();
	}, [x]);

	useEffect(() => {
		if(posts.length > 0){
			setDownloadFlag(true);
		}else{
			setDownloadFlag(false);
		}
	}, [posts]);

	//button search
	const filterData = () =>{
		setDataLoaded(false);
		searchEntity();
	}
	const searchEntity = async () => {
			if(filterType==='1'){
				await axios.get(process.env.REACT_APP_API_URL+'get_entity_data', {
					params:{
						idno: idno,
					}
				}).then((result)=> {
					setPosts(result.data.data);
					setDataLoaded(true);
				}).catch((error)=>{
					// console.log(error.message);
					setDataLoaded(true);
				})
			}else if(filterType ==='2'){
				await axios.get(process.env.REACT_APP_API_URL+'get_entity_data', {
					params:{
						customer_name: customerName,
					}
				}).then((result)=> {
					setPosts(result.data.data);
					setDataLoaded(true);
				}).catch((error)=>{
					// console.log(error.message);
					setDataLoaded(true);
				})
			}
	}

	useEffect(() => {
		if ((filterType=="1" && idno) || (filterType=="2" && customerName)) {
			setBtnDisabled(false); // re-enable
		} else {
			setBtnDisabled(true); // re-enable
		}
	}, [idno, customerName, filterType]);


	const data = async () => {
		//get data from api (for table)
		// const res = await axios.get('http://127.0.0.1/jcphq_new/public/gl_tran_report', {
		// 	params:{
		// 		date_from:'2013/01/01/', //format(dateRange.startDate, "yyyy/MM/dd/")
		// 		date_to:'2014/12/01/',   //format(dateRange.endDate, "yyyy/MM/dd/")
		// 		account_type_id:'all', //glAccFilter
		// 		jc_u_idno:'DAVAOHQ',  //input text for branchidno
		// 	}
		// })
		//res.data.data because api data is wrapped in "data"
		// console.log(res.data.data[res.data.data.length - 1]); //get the last item (grandtotal object)
	    // setPosts(res.data.data);
		//setDataLoaded(true);



	};
	const toggle = () => setOpen(!open);

	const handleModalOpen = () => {
		setModalOpen(true);
	};

	const handleModalClose = () => {
		setModalOpen(false);
	};

	const dateRangeHandler = (range) => {
		setDateRange(range);
		setOpen(false);
	};

	const columns = [
		{
			name: "idno",
			label: "ID No.",
		},
		{
			name: "atype",
			label: "Type",

		},
		{
			name: "name",
			label: "Name",

		},
		{
			name: "regdate",
			label: "Registration",
		},
		{
			name: "sprno",
			label: "Sponsor",
		},
		{
			name: "plcno",
			label: "Placement",
		},
		{
			name: "idno",
			label:"Actions",
			options: {
				sort:false, 
				filter: false, 
			  customBodyRender: (value, tableMeta, updateValue) => {
				return (
					<NavLink to={"/entity/customer-details/"+value}>
						<Button variant="contained" color="primary">
							View
						</Button>	
				   </NavLink> 
				);
			  },
			  download: false //exclude this column in csv export
			}
		}
	];

	const options = {
		filter: false,
		// filterType: "dropdown",
		selectableRows: "none",
		filterType: "multiselect",
		responsive: "standard",
		setFilterChipProps: (colIndex, colName, data) => {
			//console.log(colIndex, colName, data);
			return {
				color: "primary",
				variant: "outlined",
				className: "testClass123",
			};
		},
		download: false,  //add this
		print: false, //add this
		viewColumns :false,
		downloadOptions: {
			filename : 'CustomerInfo.csv' //change filename of csv
		}
		// tableBodyHeight,
	};
	return (
		<div className="page">
			<div className="page-header">
				<div className="page-icon">
					<AccountBalanceIcon />
				</div>
				<Breadcrumbs aria-label="breadcrumb">
					<NavLink to="/entity">
						<h2 className="header-title">Entity</h2>
					</NavLink>
					<Typography color="textPrimary">Customer Information</Typography>
				</Breadcrumbs>
			</div>
			<div className="page-container">
					<div>
						<Grid container spacing={2}>
						<Grid item xs={12} sm={4} md={4} lg={3} xl={3}>
								<NativeSelect
        						  	onChange={e => {setFilterType(e.target.value); setIdno(''); setCustomerName('');} }
        						  	inputProps={{
        						  	  name: 'GL Account',
        						  	}}>
									<option value={1}>Search By ID No.</option> 
									<option value={2}>Search By Customer Name</option>  	  
        						</NativeSelect>					
							</Grid>
							{/* show specific input based on input */}
                            <Grid item xs={12} sm={4} md={4} lg={3} xl={2}>
								{(filterType === "1") ? (
									<TextField required 
									id="standard-required" 
									label="ID No"
									inputProps={{ 'aria-label': 'description' }}
									value={idno}
									fullWidth={true}
									onChange={e => setIdno(e.target.value)}
									className={classes.textField}
									error={idno === ""}
									helperText={idno === "" ? 'Required field' : ' '}
									/>
								) : (
									<TextField required 
									id="standard-required" 
									label="Customer Name"
									inputProps={{ 'aria-label': 'description' }}
									value={customerName}
									fullWidth={true}
									onChange={e => setCustomerName(e.target.value)}
									className={classes.textField}
									error={customerName === ""}
									helperText={customerName === "" ? 'Required field' : ' '}
									/>	
								)}

							</Grid> 
							<Grid item xs={4} sm={4} md={4} lg={1} xl={1}>
								<Button disabled={btnDisabled} variant="contained" color="primary" style={{marginBottom:"12px"}} onClick={() => {filterData()}}>Search</Button>
							</Grid>		
						</Grid>
					</div>  
				{!dataLoaded ? (
					<Preloader />
				) : (
					<MUIDataTable
						title={
							<div>
								<h3 className="header-title" style={{color:"#339933"}}>
									Customer
								</h3>
							</div>
						}
						data={posts}
						columns={columns}
						options={options}
					/>
				)}
			</div>
		</div>
	);
};

export default CustomerInfo;
